var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategorias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFDC00"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC000"
    },
    d: "M512,256c0-4.746-0.139-9.458-0.394-14.14L355.377,85.632l-28.301-1.313L256,13.43l-61.419,189.027 l34.589,34.589L120.5,238.5l-2.839,63L64.5,412.57l67.337,67.337C168.613,500.344,210.943,512,256,512 C397.385,512,512,397.385,512,256z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF6838"
    },
    points: "267.5,224.609 267.5,128.381 244.5,128.381 244.5,224.609 106.161,224.609 106.161,355.431  129.161,355.431 129.161,247.609 382.839,247.609 382.839,355.431 405.839,355.431 405.839,224.609 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AE4E32"
    },
    points: "267.5,224.609 267.5,128.381 256,128.381 256,247.609 382.839,247.609 382.839,355.431  405.839,355.431 405.839,224.609 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 306.25,
    style: {
      fill: "#008CC3"
    },
    width: 106.32,
    height: 106.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 341.18,
    y: 306.25,
    style: {
      fill: "#0074A3"
    },
    width: 106.32,
    height: 106.32
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0074A3"
    },
    points: "256,13.43 286.709,75.654 355.377,85.632 305.689,134.066 317.419,202.457 256,170.167  194.581,202.457 206.311,134.066 156.623,85.632 225.291,75.654  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#005C83"
    },
    points: "355.377,85.632 286.709,75.654 256,13.43 256,170.167 317.419,202.457 305.689,134.066 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorias);
export default __webpack_public_path__ + "static/media/categorias.afb7a2231925631410b079b040900e1a.svg";
export { ForwardRef as ReactComponent };